import React from "react";
import * as Styled from "./styles";

export default function Divider({ children }) {
  return <Styled.Divider>{children}</Styled.Divider>;
}
